/**
 * A realistic language-school calendar, in the shape Google Calendar exports:
 * folded lines, a VTIMEZONE block, multi-value EXDATE, an RDATE, three detached
 * overrides, alarms, and private X- properties.
 */
export const SAMPLE_ICS = `BEGIN:VCALENDAR
PRODID:-//Google Inc//Google Calendar 70.9054//EN
VERSION:2.0
CALSCALE:GREGORIAN
METHOD:PUBLISH
X-WR-CALNAME:Language School
X-WR-TIMEZONE:Asia/Seoul
BEGIN:VTIMEZONE
TZID:Asia/Seoul
X-LIC-LOCATION:Asia/Seoul
BEGIN:STANDARD
TZOFFSETFROM:+0900
TZOFFSETTO:+0900
TZNAME:KST
DTSTART:19700101T000000
END:STANDARD
END:VTIMEZONE
BEGIN:VEVENT
DTSTART;TZID=Asia/Seoul:20260303T190000
DTEND;TZID=Asia/Seoul:20260303T210000
RRULE:FREQ=WEEKLY;BYDAY=TU;UNTIL=20261229T100000Z
EXDATE;TZID=Asia/Seoul:20260505T190000
EXDATE;TZID=Asia/Seoul:20260922T190000,20261006T190000
RDATE;TZID=Asia/Seoul:20261111T190000
DTSTAMP:20260220T041500Z
UID:advanced-korean-tue@school.example.com
CREATED:20260220T041500Z
DESCRIPTION:Advanced conversation and composition.\\nBring the workbook and 
 last week's essay draft.
LAST-MODIFIED:20260814T092200Z
LOCATION:Seoul Language Institute\\, Room A-201
SEQUENCE:3
STATUS:CONFIRMED
SUMMARY:Advanced Korean — Tuesday Evening Class
TRANSP:OPAQUE
CATEGORIES:Teaching,Recurring
ORGANIZER;CN=Ji-woo Park:mailto:jiwoo.park@school.example.com
ATTENDEE;CUTYPE=INDIVIDUAL;ROLE=REQ-PARTICIPANT;PARTSTAT=ACCEPTED;CN=Hyunsik
  Lee:mailto:hyunsik@example.com
ATTENDEE;CUTYPE=INDIVIDUAL;ROLE=REQ-PARTICIPANT;PARTSTAT=ACCEPTED;CN=Mina Ch
 oi:mailto:mina.choi@example.com
X-SCHOOL-COURSE-CODE:KOR-401
X-SCHOOL-BILLING-UNIT:TERM-2026-2
BEGIN:VALARM
ACTION:DISPLAY
DESCRIPTION:Class in 30 minutes
TRIGGER:-PT30M
END:VALARM
END:VEVENT
BEGIN:VEVENT
DTSTART;TZID=Asia/Seoul:20260407T190000
DTEND;TZID=Asia/Seoul:20260407T210000
RECURRENCE-ID;TZID=Asia/Seoul:20260407T190000
DTSTAMP:20260401T041500Z
UID:advanced-korean-tue@school.example.com
CREATED:20260220T041500Z
LAST-MODIFIED:20260401T041500Z
LOCATION:Seoul Language Institute\\, Room C-105 (A-201 under repair)
SEQUENCE:4
STATUS:CONFIRMED
SUMMARY:Advanced Korean — Tuesday Evening Class
X-SCHOOL-ROOM-SWAP:maintenance
END:VEVENT
BEGIN:VEVENT
DTSTART;TZID=Asia/Seoul:20260916T190000
DTEND;TZID=Asia/Seoul:20260916T210000
RECURRENCE-ID;TZID=Asia/Seoul:20260915T190000
DTSTAMP:20260901T041500Z
UID:advanced-korean-tue@school.example.com
CREATED:20260220T041500Z
DESCRIPTION:Make-up session moved to Wednesday because of the school open da
 y.
LAST-MODIFIED:20260901T041500Z
LOCATION:Seoul Language Institute\\, Room A-201
SEQUENCE:5
STATUS:CONFIRMED
SUMMARY:Advanced Korean — MAKE-UP (Wednesday)
X-SCHOOL-MAKEUP-FOR:20260915
BEGIN:VALARM
ACTION:DISPLAY
DESCRIPTION:Make-up class tomorrow
TRIGGER:-P1D
END:VALARM
END:VEVENT
BEGIN:VEVENT
DTSTART;TZID=Asia/Seoul:20261020T190000
DTEND;TZID=Asia/Seoul:20261020T210000
RECURRENCE-ID;TZID=Asia/Seoul:20261020T190000
DTSTAMP:20261001T041500Z
UID:advanced-korean-tue@school.example.com
CREATED:20260220T041500Z
LAST-MODIFIED:20261001T041500Z
LOCATION:Seoul Language Institute\\, Room B-302 (guest lecture)
SEQUENCE:6
STATUS:CONFIRMED
SUMMARY:Advanced Korean — Guest Lecture
ATTENDEE;CUTYPE=INDIVIDUAL;ROLE=REQ-PARTICIPANT;PARTSTAT=ACCEPTED;CN=Hyunsik
  Lee:mailto:hyunsik@example.com
ATTENDEE;CUTYPE=INDIVIDUAL;ROLE=REQ-PARTICIPANT;PARTSTAT=ACCEPTED;CN=Mina Ch
 oi:mailto:mina.choi@example.com
ATTENDEE;CUTYPE=INDIVIDUAL;ROLE=OPT-PARTICIPANT;PARTSTAT=TENTATIVE;CN=Dr. Se
 o-yeon Han:mailto:seoyeon.han@univ.example.ac.kr
X-SCHOOL-GUEST-SPEAKER:Dr. Seo-yeon Han
END:VEVENT
END:VCALENDAR
`;
